import React, { useState } from 'react'
import {
  Button,
  Toast,
  toastManager,
  ToastManagerOptions,
} from '@therms/atalaya'

function ErrorDetails({
  details,
  message,
}: {
  details?: string
  message: string
}) {
  const [viewDetails, setViewDetails] = useState(false)
  return (
    <div className="space-y-2 text-center">
      <div>{message}</div>
      {details && !viewDetails && (
        <Button variant="critical" subtle onClick={() => setViewDetails(true)}>
          View Details
        </Button>
      )}
      {viewDetails && (
        <div className="font-light">
          <em>{details}</em>
        </div>
      )}
    </div>
  )
}
/**
 * Alerts are for showing the user feedback on the UI that is directly in front of them (what they are looking at
 * or interacting with).
 *
 * Notifications are for all other "notifications" that need the user's attention
 */
export const Alerts = {
  error: (message, details?: string, opts?: ToastManagerOptions) => {
    toastManager(
      <Toast hideCloseButton>
        <ErrorDetails details={details} message={message} />
      </Toast>,
      {
        autoClose: 2000,
        hideProgressBar: true,
        position: toastManager.POSITION.BOTTOM_CENTER,
        variant: 'critical',
        ...(opts || {}),
      },
    )
  },
  success: (message, opts?: ToastManagerOptions) => {
    toastManager(
      <Toast hideCloseButton>
        <div className="text-center">{message}</div>
      </Toast>,
      {
        autoClose: 2000,
        hideProgressBar: true,
        position: toastManager.POSITION.BOTTOM_CENTER,
        variant: 'positive',
        ...(opts || {}),
      },
    )
  },
}
